import { Conversation, ConversationParticipant } from '../../models/chat';
import { formatLocale } from '../../providers/dayjs-plugins';

/** Matches a string that contains ONLY emoji characters (no plain text). */
export const EMOJI_ONLY_RE =
  /^(?:\p{Emoji_Modifier_Base}\p{Emoji_Modifier}?|\p{Emoji_Presentation}|\p{Emoji}\uFE0F)(?:\s*(?:\p{Emoji_Modifier_Base}\p{Emoji_Modifier}?|\p{Emoji_Presentation}|\p{Emoji}\uFE0F))*$/u;

/**
 * Matches any single emoji character within a string.
 * NOTE: No `g` flag — module-level regex constants with `g` retain `lastIndex`
 * state between calls, which causes alternating true/false on .test().
 */
export const EMOJI_RE =
  /((?:\p{Emoji_Modifier_Base}\p{Emoji_Modifier}?|\p{Emoji_Presentation}|\p{Emoji}\uFE0F))/u;

export const EMOJI_PART_RE =
  /((?:\p{Emoji_Modifier_Base}\p{Emoji_Modifier}?|\p{Emoji_Presentation}|\p{Emoji}\uFE0F))/u;

export function getHeaderTitle(view: string): string {
  if (view === 'list') return 'Conversas';
  if (view === 'users') return 'Nova Conversa';
  if (view === 'new-group') return 'Novo Grupo';
  return 'Conversas';
}

export function getActiveChatTitle(
  conversations: Conversation[],
  activeConversationId: number | undefined,
  userId: number | undefined,
  selectedUser: { id: number; name: string; email: string } | null,
): string {
  if (!activeConversationId && selectedUser) return selectedUser.name;
  if (!activeConversationId) return 'Chat';

  const conv = conversations.find((c) => c.id === activeConversationId);
  if (conv?.type === 'group') return conv.name || 'Grupo';

  const other = conv?.participants.find(
    (p: ConversationParticipant) => p.user.id !== userId,
  );
  return other?.user.username ?? 'Chat';
}

export function getDayLabel(dateStr: string): string {
  const date = new Date(dateStr);
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const msgDay = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  const diffDays = Math.round(
    (today.getTime() - msgDay.getTime()) / (1000 * 60 * 60 * 24),
  );

  if (diffDays === 0) return 'Hoje';
  if (diffDays === 1) return 'Ontem';
  return formatLocale(dateStr, 'DD/MM/YYYY');
}

export function getDateKey(dateStr: string): string {
  const d = new Date(dateStr);
  return `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`;
}
